import Report from "app/screens/ReportsScreen/components/MobileReportsScreen/components/Report";
import { BetFormats } from "app/utils/const";
import React from "react";
import "./OpenBetsContent.scss";

import type { ReportBetMobileType } from "app/types/reportType";

type Props = {
  reportList: ReportBetMobileType[];
  isReportListLoading: boolean;
};

const OpenBetsContent: React.FC<Props> = ({
  reportList,
  isReportListLoading,
}) => {
  if (!reportList || isReportListLoading) {
    return null;
  }

  return (
    <>
      {reportList.map((bet, index) => {
        const {
          betId,
          betType,
          marketName,
          translatedBetType,
          legs,
          eventName: defaultEventName,
        } = bet || {};

        const isValidLegs = Array.isArray(legs) && legs?.length > 0;

        const eventName =
          betType === BetFormats.BET_BUILDER && isValidLegs
            ? legs?.[0]?.eventName
            : defaultEventName;

        return (
          <Report
            key={betId.toString()}
            bet={bet}
            marketName={marketName}
            eventName={eventName}
            contentType=""
            translatedBetType={translatedBetType}
            betType={betType}
          />
        );
      })}
    </>
  );
};

export default React.memo(OpenBetsContent);
